import * as React from "react";
const SvgFiRrCloudMeatball = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-meatball_svg__a)">
      <path
        fill="#062147"
        d="M20 22.5a1.5 1.5 0 1 1-3.001 0 1.5 1.5 0 0 1 3.001 0M4.5 21a1.5 1.5 0 1 0 .001 3.002A1.5 1.5 0 0 0 4.5 21M17.974 5.147a1.03 1.03 0 0 1-.742-.569c-1.551-3.27-5.143-5.096-8.735-4.44A7.95 7.95 0 0 0 2.113 6.64a8.1 8.1 0 0 0 .033 2.89c.06.308-.072.653-.345.902A5.5 5.5 0 0 0 0 14.5a5.47 5.47 0 0 0 4.278 5.364q.112.025.223.025a.999.999 0 0 0 .221-1.976A3.525 3.525 0 0 1 2 14.5c0-.983.418-1.928 1.146-2.59.786-.715 1.155-1.773.963-2.762a6.1 6.1 0 0 1-.024-2.18c.403-2.423 2.365-4.422 4.771-4.863 2.745-.504 5.385.835 6.567 3.33a3.02 3.02 0 0 0 2.158 1.672 5.51 5.51 0 0 1 4.417 5.395 5.49 5.49 0 0 1-3.385 5.079 1 1 0 0 0-.538 1.308 1 1 0 0 0 1.308.538 7.48 7.48 0 0 0 4.615-6.924c0-3.566-2.534-6.659-6.026-7.355zM14.927 18.07c.299-.566.231-1.274-.246-1.75-.477-.478-1.185-.546-1.751-.247a1.495 1.495 0 0 0-1.431-1.072c-.679 0-1.246.454-1.431 1.072-.566-.299-1.274-.23-1.751.247-.477.476-.545 1.185-.246 1.75a1.495 1.495 0 0 0-1.072 1.431c0 .68.454 1.246 1.072 1.431-.299.567-.231 1.276.246 1.752.293.293.677.438 1.061.438.241 0 .472-.078.69-.194a1.495 1.495 0 0 0 1.431 1.073c.679 0 1.246-.454 1.431-1.073.218.116.45.194.69.194.384 0 .768-.145 1.061-.439.477-.476.545-1.184.246-1.75a1.495 1.495 0 0 0 1.072-1.431c0-.68-.454-1.246-1.072-1.431"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-meatball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudMeatball;
